organizations<fs-sidenav-menu>
<div class="title">
  <h2>Organizations</h2>
</div>
<div class="search">
  <fs-filter [config]="config"></fs-filter>
</div>
<fs-sidenav-menu-content>
  @for (organization of organizations; track organization) {
    <div class="organization">
      @if (organization.image) {
        <fs-badge [image]="organization.image.small" [size]="30"></fs-badge>
      }
      <div class="organization-info">
        <span class="organization-header">{{ organization.name }}</span>
        <div class="organization-links">
          <a [routerLink]="['../organizations', organization.id]" (click)="close()">
            Organization
          </a>
          <a [routerLink]="['../organizations', organization.id, 'programs']" (click)="close()">
            Programs
          </a>
          <a [routerLink]="['../organizations', organization.id, 'parents']" (click)="close()">
            Parents
          </a>
          <a [routerLink]="['../organizations', organization.id, 'students']" (click)="close()">
            Students
          </a>
          <a [routerLink]="['../organizations', organization.id, 'enrollments']" (click)="close()">
            Enrollments
          </a>
          <a [routerLink]="['../organizations', organization.id, 'invoices']" (click)="close()">
            Invoices
          </a>
        </div>
      </div>
    </div>
  }
</fs-sidenav-menu-content>
<fs-sidenav-menu-actions class="actions">
  <button mat-button color="primary" (click)="close()" type="button" class="full-width">Done</button>
</fs-sidenav-menu-actions>
</fs-sidenav-menu>
